import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function BlogPreviewSection() {
  // Show articles 2-10 (skip the first one which is already in SEOSection)
  const previewArticles = articles.slice(1);

  const handleArticleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="blog" className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-foreground-400 uppercase tracking-[0.2em]">Блог и руководства</span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mt-3 leading-tight">
            Полезные статьи<br />о закупках из Китая
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            Экспертные руководства, сравнения платформ и стратегии для вашего бизнеса
          </p>
        </div>

        {/* Articles grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {previewArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={handleArticleClick}
              className="group flex flex-col bg-background-50 border border-background-200 rounded-2xl overflow-hidden hover:border-background-300 transition-all duration-300 cursor-pointer"
            >
              {/* Article image */}
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-semibold rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>

              {/* Article info */}
              <div className="flex-1 flex flex-col gap-3 p-4 md:p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-calendar-line text-xs"></i>
                    </span>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-time-line text-xs"></i>
                    </span>
                    {article.readTime}
                  </span>
                </div>

                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>

                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>

                <div className="mt-auto pt-2 flex items-center gap-2 text-xs font-semibold text-primary-500 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  Читать далее
                  <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom note */}
        <p className="text-center text-xs text-foreground-400 mt-10">
          Все статьи основаны на реальном опыте пользователей YOYBUY Spreadsheet и обновляются ежемесячно.
        </p>
      </div>
    </section>
  );
}